import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './InfoTooltip.css';

function InfoTooltip({ contentKey, os = null }) {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const getTooltipContent = () => {
    if (os) {
      return t(contentKey, { os });
    }
    return t(contentKey);
  };

  return (
    <span 
      className="info-tooltip-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <span className="info-icon">ℹ️</span>
      {isVisible && (
        <div className="info-tooltip">
          {getTooltipContent()}
        </div>
      )}
    </span>
  );
}

export default InfoTooltip;

